module.exports = __webpack_public_path__ + "static/media/slunicko_montessori.0fb25f3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/sponsors/slunicko_montessori.jpg
// module id = 503
// module chunks = 0